import { raiseError } from 'utils/postMessage/sendMessages';

window.addEventListener('error', event => {
  raiseError(`UNHANDLED ERROR: ${event.type}: ${event.message}`);
});
